import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import { useState } from "react";
import { selectClientLensFormId } from "redux/slices/clientLens";
import { useAppSelector } from "redux/hooks";
import SectionValuesImport from "./SectionValuesImport";

export function SectionValueImportDialog({ onClose }: { onClose: () => void }) {
  const formId = useAppSelector(selectClientLensFormId);
  const [, setHasFile] = useState(false);

  const handleClose = () => {
    setHasFile(false);
    onClose();
  };

  return (
    <Dialog open={true} fullWidth maxWidth="md">
      <DialogTitle>Import Sections</DialogTitle>
      <DialogContent>
        <SectionValuesImport onClose={handleClose} formId={formId} onFileChange={(hasFile) => setHasFile(hasFile)} />
      </DialogContent>
    </Dialog>
  );
}
